/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteMaintenanceVehicleConditionParams,
  GetMaintenanceVehicleConditionParams,
  MaintenanceVehicleCondition,
  MaintenanceVehicleConditionInsertPayload,
  MaintenanceVehicleConditionUpdate,
  PatchMaintenanceVehicleConditionParams,
  PostMaintenanceVehicleConditionParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getMaintenanceVehicleConditionResponse200 = {
  data: MaintenanceVehicleCondition[]
  status: 200
}

export type getMaintenanceVehicleConditionResponse206 = {
  data: MaintenanceVehicleCondition[]
  status: 206
}

export type getMaintenanceVehicleConditionResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getMaintenanceVehicleConditionResponseSuccess = (getMaintenanceVehicleConditionResponse200 | getMaintenanceVehicleConditionResponse206) & {
  headers: Headers;
};
export type getMaintenanceVehicleConditionResponseError = (getMaintenanceVehicleConditionResponseDefault) & {
  headers: Headers;
};

export type getMaintenanceVehicleConditionResponse = (getMaintenanceVehicleConditionResponseSuccess | getMaintenanceVehicleConditionResponseError)

export const getGetMaintenanceVehicleConditionUrl = (params?: GetMaintenanceVehicleConditionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_vehicle_condition?${stringifiedParams}` : `${backendBaseUrl}/maintenance_vehicle_condition`
}

/**
 * @summary Read rows from `maintenance_vehicle_condition`.
 */
export const getMaintenanceVehicleCondition = async (params?: GetMaintenanceVehicleConditionParams, options?: RequestInit): Promise<getMaintenanceVehicleConditionResponse> => {

  const res = await fetch(getGetMaintenanceVehicleConditionUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMaintenanceVehicleConditionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getMaintenanceVehicleConditionResponse
}


export type postMaintenanceVehicleConditionResponse201 = {
  data: MaintenanceVehicleCondition[]
  status: 201
}

export type postMaintenanceVehicleConditionResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postMaintenanceVehicleConditionResponseSuccess = (postMaintenanceVehicleConditionResponse201) & {
  headers: Headers;
};
export type postMaintenanceVehicleConditionResponseError = (postMaintenanceVehicleConditionResponseDefault) & {
  headers: Headers;
};

export type postMaintenanceVehicleConditionResponse = (postMaintenanceVehicleConditionResponseSuccess | postMaintenanceVehicleConditionResponseError)

export const getPostMaintenanceVehicleConditionUrl = (params?: PostMaintenanceVehicleConditionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_vehicle_condition?${stringifiedParams}` : `${backendBaseUrl}/maintenance_vehicle_condition`
}

/**
 * @summary Insert one or more rows into `maintenance_vehicle_condition`.
 */
export const postMaintenanceVehicleCondition = async (maintenanceVehicleConditionInsertPayload: MaintenanceVehicleConditionInsertPayload,
    params?: PostMaintenanceVehicleConditionParams, options?: RequestInit): Promise<postMaintenanceVehicleConditionResponse> => {

  const res = await fetch(getPostMaintenanceVehicleConditionUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceVehicleConditionInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postMaintenanceVehicleConditionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postMaintenanceVehicleConditionResponse
}


export type patchMaintenanceVehicleConditionResponse200 = {
  data: MaintenanceVehicleCondition[]
  status: 200
}

export type patchMaintenanceVehicleConditionResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchMaintenanceVehicleConditionResponseSuccess = (patchMaintenanceVehicleConditionResponse200) & {
  headers: Headers;
};
export type patchMaintenanceVehicleConditionResponseError = (patchMaintenanceVehicleConditionResponseDefault) & {
  headers: Headers;
};

export type patchMaintenanceVehicleConditionResponse = (patchMaintenanceVehicleConditionResponseSuccess | patchMaintenanceVehicleConditionResponseError)

export const getPatchMaintenanceVehicleConditionUrl = (params?: PatchMaintenanceVehicleConditionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_vehicle_condition?${stringifiedParams}` : `${backendBaseUrl}/maintenance_vehicle_condition`
}

/**
 * @summary Update the rows of `maintenance_vehicle_condition` matching the given filters.
 */
export const patchMaintenanceVehicleCondition = async (maintenanceVehicleConditionUpdate: MaintenanceVehicleConditionUpdate,
    params?: PatchMaintenanceVehicleConditionParams, options?: RequestInit): Promise<patchMaintenanceVehicleConditionResponse> => {

  const res = await fetch(getPatchMaintenanceVehicleConditionUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceVehicleConditionUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchMaintenanceVehicleConditionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchMaintenanceVehicleConditionResponse
}


export type deleteMaintenanceVehicleConditionResponse200 = {
  data: MaintenanceVehicleCondition[]
  status: 200
}

export type deleteMaintenanceVehicleConditionResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMaintenanceVehicleConditionResponseSuccess = (deleteMaintenanceVehicleConditionResponse200) & {
  headers: Headers;
};
export type deleteMaintenanceVehicleConditionResponseError = (deleteMaintenanceVehicleConditionResponseDefault) & {
  headers: Headers;
};

export type deleteMaintenanceVehicleConditionResponse = (deleteMaintenanceVehicleConditionResponseSuccess | deleteMaintenanceVehicleConditionResponseError)

export const getDeleteMaintenanceVehicleConditionUrl = (params?: DeleteMaintenanceVehicleConditionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_vehicle_condition?${stringifiedParams}` : `${backendBaseUrl}/maintenance_vehicle_condition`
}

/**
 * @summary Delete the rows of `maintenance_vehicle_condition` matching the given filters.
 */
export const deleteMaintenanceVehicleCondition = async (params?: DeleteMaintenanceVehicleConditionParams, options?: RequestInit): Promise<deleteMaintenanceVehicleConditionResponse> => {

  const res = await fetch(getDeleteMaintenanceVehicleConditionUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteMaintenanceVehicleConditionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteMaintenanceVehicleConditionResponse
}


